import React, { FC } from 'react';
import { SvgType } from '../../types';

export const SquareCheckSvgComponent: FC<SvgType> = ({ color = '#000' }) => {
  return (
    <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
      <path d='M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z' fill={ color } />
    </svg>
  );
};
